import type { CopyShape } from "@tami/core/intl";

import type { APP_PAGES_COPY_PT_BR } from "../pages.copy";

export const APP_PAGES_COPY_ES_ES: CopyShape<typeof APP_PAGES_COPY_PT_BR> = {
  error: {
    title: "¡Algo ha fallado!",
    description: "Parece que nuestro servidor ha tenido un problema inesperado. 😔",
    back: "Volver",
  },
  notFound: {
    title: "Página no encontrada :(",
    description: "Parece que no hemos encontrado la página que buscabas.",
    back: "Volver",
    reload: "Recargar",
  },
  demo: {
    title: "Demo interactiva",
    description:
      "Descubre Tãmi por dentro: contenido, campañas, agenda, finanzas y el asistente de WhatsApp. Haz clic en los puntos marcados o deja que el tour guiado te lo enseñe todo.",
    heading: "Demo interactiva de Tãmi",
    backAria: "Volver a la web",
    back: "Volver",
    signUp: "Crear cuenta gratis",
  },
  links: {
    title: "Enlaces",
    description:
      "Crea tu cuenta, mira la demo por dentro y habla con nosotros: los enlaces de Tãmi, la herramienta que organiza la vida de creators y Collabs.",
  },
  signTagline: "Tú creas. Tãmi organiza.",
  dataDeletion: {
    metaTitle: "Solicitud de eliminación de datos",
    title: "Hemos recibido tu solicitud de eliminación de datos",
    received: "Tu solicitud de eliminación de datos de Instagram se ha recibido y procesado.",
    revokeIntro:
      "Cuando revocas el acceso de Tãmi a tu Instagram o solicitas la eliminación de tus datos directamente a través de Meta, borramos de inmediato:",
    deletedConnection: "la conexión entre tu cuenta de Tãmi y tu cuenta de Instagram;",
    deletedToken: "el token de acceso asociado a esa conexión;",
    deletedMetrics: "los seguidores, las publicaciones y las métricas de Instagram que guardábamos.",
    immediate:
      "Esta eliminación se produce en cuanto recibimos la solicitud, sin que tengas que hacer nada más, y a partir de ese momento no se recopila ningún dato nuevo de Instagram. Lo que está en el propio Instagram no se ve afectado. Para volver a seguir tu rendimiento en Tãmi, solo tienes que conectar la cuenta de nuevo.",
    contactBefore: "Si tienes cualquier duda sobre la eliminación, escribe a",
    supportEmail: "suporte@tamiapp.com",
    contactAfter: ". Respondemos en un plazo de 15 días, como exige la LGPD brasileña.",
    questionsBefore: "Puedes resolver tus dudas sobre cómo tratamos tus datos en nuestra",
    privacyLink: "política de privacidad",
  },
};
